import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import ApartmentForm from '../components/buildings/ApartmentForm'
import useApartmentsApi from '../hooks/apartments/useApartmentsApi'

export default function CreateApartmentPage() {
  const history = useHistory()
  const location = useLocation()
  const [_, apartmentsMethods] = useApartmentsApi()

  const { buildingId, item, previousRoute, selectedTab } = location.state || {}

  return (
    <ApartmentForm
      buildingId={buildingId}
      onSubmit={(values) => {
        if (values.id) {
          apartmentsMethods.updateApartment({ ...values, buildingId })
        } else {
          apartmentsMethods.createApartment({ ...values, buildingId })
        }
        history.push(previousRoute, { selectedTab })
      }}
      handleCancel={() => history.push(previousRoute, { selectedTab })}
      apartment={item}
    />
  )
}
